import { Tabs } from "antd";
import React, { FC, useEffect, useState } from "react";
import { deserialize } from "serializr";
import { MetaModel } from "../../models/CourseModels/SubjectModel/subject.model";
import { Institutes } from "../../models/InstituteModel/institutes.model";
import InstituteService from "../../services/InstituteService/institute.service";
import CommonService from "../../services/CommonService/common.service"
import AppHeader from "../../shared/components/AppHeader";
import EmptyState from "../../shared/components/EmptyState";
import ClassroomLeaderboard from "./ClassroomLeaderboard";
import ExamLeaderboard from "./ExamLeaderboard";
import "./leaderboard.scss";
const { TabPane } = Tabs;

const Leaderboard: FC = (props: any) => {
  const [institutes, setInstitutes] = useState<MetaModel[]>([]);

  const fetchInstitutes = () => {
    CommonService.fetchInstitutesMeta(
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setInstitutes(meta);
      },
      () => { },
      () => { }
    );
  };

  useEffect(() => {
    fetchInstitutes();
  }, []);

  return (
    //     <div className='page-view'>
    //     <EmptyState text={'Coming soon...'}/>
    // </div>
    <div className="page-view leaderboard">
      <AppHeader
        headerText="Leaderboard"
        showBreadCrumb={false}
        showFilter={false}
        showSearch={false}
        showButton={false}
      />
      <Tabs defaultActiveKey="1">
        <TabPane key="1" tab="Board">
          <ClassroomLeaderboard institutes={institutes} {...props} />
        </TabPane>
        <TabPane key="2" tab="Exam">
          <ExamLeaderboard institutes={institutes} {...props} />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Leaderboard;
